export const selectTalentManager = (state) => state.talentManager;
